import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { omit } from 'lodash';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withFirebase } from 'react-redux-firebase';

const styles = theme => ({
  productImage: {
    maxWidth: '200px',
    maxHeight: '200px',
    marginTop: '30px'
  },
  uploadButton: {
    height: '50px'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    null
  ),
  withFirebase,
  withStyles(styles)
);

function ProductPictureUpload(props) {
  const { classes, firebase, uploadHandler, productPhotoUrl } = props;

  const onDropAccepted = useCallback(acceptedFile => {
    var user = firebase.auth().currentUser;

    const filePath = `${user.uid}/productPictures/`;

    const options = {
      metadataFactory: uploadRes => {
        const { metadata } = uploadRes;
        const cleanMeta = omit(metadata, [
          'cacheControl',
          'contentLanguage',
          'customMetadata'
        ]);
        return cleanMeta;
      }
    };

    firebase
      .uploadFiles(filePath, acceptedFile, filePath, options)
      .then(file => {
        file[0].uploadTaskSnapshot.ref.getDownloadURL().then(downloadUrl => {
          uploadHandler(downloadUrl);
        });
      });
  }, []);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: 'image/jpeg, image/png',
    onDropAccepted: onDropAccepted
  });

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="primary"
        className={classes.uploadButton}
      >
        <div
          {...getRootProps({ className: 'dropzone' })}
          className="dropzone-container"
        >
          <input {...getInputProps()} />
          <div>Upload</div>
        </div>
      </Button>
      <div>{productPhotoUrl && 'upload success!'}</div>
    </React.Fragment>
  );
}

ProductPictureUpload.propTypes = {
  classes: PropTypes.object.isRequired,
  uploadHandler: PropTypes.func,
  productPhotoUrl: PropTypes.string
};

export default enhance(ProductPictureUpload);



// WEBPACK FOOTER //
// ./src/components/company/campaign/components/ProductPhotoUpload.js